// DEV Environment (GCP Cloud - Testing)
export const environment = {
  production: false,
  apiUrl: 'https://backend-924068591736.asia-south1.run.app/api',
  googleClientId: '924068591736-rjsj0743euskukupkt4oonjcd8et4ijf.apps.googleusercontent.com'
};
